module.exports = __webpack_public_path__ + "img/payment.248b7885.svg";